import React from "react";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch } from "react-redux";
import { actionCreators } from "../redux/DemographicsSagas";
import PropTypes from "prop-types";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

const Filters = ({
  options,
  selectedFilters,
  name,
  label,
  selectAllText,
  allSelectedPlaceholder,
  numberDisplayed,
  includeFilter = true,
  includeSelectAll = true,
  enableOnly = true,
  isLoadingFilters,
  width = ""
}) => {
  const dispatch = useDispatch();
  return (
    <div className="select-box-no-width categories" style={{ width }}>
      <p>{label}</p>
      {isLoadingFilters ? (
        <LoadingAnimation uiLoader />
      ) : (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selectedFilters}
          allSelectedPlaceholder={allSelectedPlaceholder}
          selectAllText={selectAllText}
          height={375}
          includeFilter={includeFilter}
          numberDisplayed={numberDisplayed}
          includeSelectAll={includeSelectAll}
          enableOnly={enableOnly}
          onSelectChange={(data) => dispatch(actionCreators.updateSelectedFilter({ data, name }))}
        />
      )}
    </div>
  );
};

Filters.propTypes = {
  options: PropTypes.array,
  selectedFilters: PropTypes.any,
  name: PropTypes.string,
  label: PropTypes.string,
  selectAllText: PropTypes.string,
  allSelectedPlaceholder: PropTypes.string,
  numberDisplayed: PropTypes.number,
  includeFilter: PropTypes.bool,
  includeSelectAll: PropTypes.bool,
  enableOnly: PropTypes.bool
};

export default React.memo(Filters);
